import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { REQUEST, SEND } from 'apps/auth/constants/Constants';
import { AUTH_REQUEST_MAIN_LINK, AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import { MenuItem } from './MenuItem';
import { Container, Menu } from './styles';

interface BottomMenuProps {
    currentPage?: string;
}

type BottomMenuMessages = {
    sideBarMenu_transfer?: string;
    sideBarMenu_request?: string;
};

const BottomMenuComponent: React.FC<BottomMenuProps> = (props) => {
    const { sideBarMenu_transfer: transferTitle, sideBarMenu_request: requestTitle } = usePageMessages<BottomMenuMessages>() ?? {};

    const menuItems = [
        {
            isSelected: props.currentPage === SEND,
            link: AUTH_SEND_MAIN_LINK,
            title: transferTitle,
            testId: 'send',
            iconId: 'transfers',
        },
        {
            isSelected: props.currentPage === REQUEST,
            link: AUTH_REQUEST_MAIN_LINK,
            title: requestTitle,
            testId: 'request',
            iconId: 'receipt',
        },
    ];
    return (
        <Container>
            <Menu>
                {menuItems.map((item, index) => (
                    <MenuItem {...item} key={index} />
                ))}
            </Menu>
        </Container>
    );
};

export default connect(null, { toggleSpinner })(BottomMenuComponent);
